"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverSchema = void 0;
const zod_1 = require("zod");
exports.driverSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    fullName: zod_1.z.string(),
    phone: zod_1.z.string().optional(),
    email: zod_1.z.string().email().optional(),
    licenseNumber: zod_1.z.string().optional(),
    licenseExpiry: zod_1.z.string().optional(),
    avatarUrl: zod_1.z.string().url().optional(),
    status: zod_1.z.enum(["on_duty", "off_duty", "inactive"]).optional(),
});
